module.exports = __webpack_public_path__ + "img/szfw-glfw.ee74cdeb.png";